import * as React from 'react'

import styled, { css } from 'styled-components'
import { theme } from 'global'
import { IHand } from 'models'

import { AnimalIconPaths } from './AnimalIconPaths'

export interface IAnimalIcon {
  viewBox?: string
  width?: string
  height?: string
  maxHeight?: string
  name?: IHand['animal']
  color?: string
  singleLayer?: boolean
  flipped?: boolean
}

const SVG = styled.svg<IAnimalIcon>`
  ${({ maxHeight }) =>
    css`
      max-height: ${maxHeight};
    `}
`

export const AnimalIcon = ({
  width = '24px',
  // Default height is the icon.maxHeight, this is for pdf printing support.
  // To scale the height automatically based on width, pass in prop `height: '100%'`.
  height,
  name = 'cougar',
  viewBox = '24',
  flipped = false,
  color = theme.colors.kinkyPurple,
  singleLayer = false,
  ...props
}: IAnimalIcon) => {
  const icon = AnimalIconPaths[name as keyof typeof AnimalIconPaths]
  const viewBoxString = icon.viewBox
    ? icon.viewBox
    : `0 0 ${viewBox} ${viewBox}`
  const iconGroups = singleLayer
    ? icon.groups.filter(i => !i.fill)
    : icon.groups

  return (
    <SVG
      viewBox={viewBoxString}
      width={width}
      height={height || icon.maxHeight}
      transform={flipped ? `scale(-1,1) translate(-0,0)` : ''}
      {...props}
    >
      <g
        id='O.school'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='nonzero'
      >
        {iconGroups.map((group, i) => (
          <React.Fragment key={i}>
            {group.path && (
              <path
                fill={group.fill || color}
                d={group.path}
                transform={group.transform}
              />
            )}
            {group.polygon && (
              <polygon
                fill={group.fill || color}
                points={group.polygon}
                transform={group.transform}
              />
            )}
          </React.Fragment>
        ))}
      </g>
    </SVG>
  )
}
